/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '../../environments/environment';
import {User} from '../model';
import {RestResponse} from '../model';
import {ApiHeaders} from './headers';

@Injectable()
export class AuthProvider {

  constructor(
    private http: HttpClient
  ) {}

  authenticate(email: string, password: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(environment.API_URL + '/api/auth', {
        email: email,
        password: password
      }, ApiHeaders.getOptions());
  }

  authVerify(email: string, password: string, code: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(environment.API_URL + '/api/auth/verify', {
        email: email,
        password: password,
        code: code
      }, ApiHeaders.getOptions());
  }

  requestReset(email: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/auth/reset?email=${email}`, null, ApiHeaders.getOptions());
  }

  completeReset(code: string, password: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/auth/reset/${code}`, {
        password: password
      }, ApiHeaders.getOptions());
  }

  getUserByCode(code: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/auth/code/${code}`, ApiHeaders.getOptions());
  }

  register(user: User, code: string, password: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/auth/register?code=${code}`, {
        USER: user,
        PASSWORD: password
      }, ApiHeaders.getOptions());
  }

  generateCode(email: any, reportId: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(environment.API_URL + '/api/external/link/code', {
        EMAIL: email,
        REPORT_ID: reportId
      }, ApiHeaders.getOptions());
  }

  externalAuthVerify(email: any, reportId: any, code: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(environment.API_URL + '/api/external/link/verify-code', {
        EMAIL: email,
        REPORT_ID: reportId,
        CODE: code
      }, ApiHeaders.getOptions());
  }
}
